var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLeftArrowSymbol(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "30px",
    height: "30px",
    viewBox: "0 0 30 30",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "NAV ICON - LEFT ARROW") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SWITCHBOARD",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "SWITCHBOARD-ART",
    transform: "translate(-250.000000, -95.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(250.000000, 95.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#FFFFFF",
    cx: 15,
    cy: 15,
    r: 15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22,9 L21.999,12.363 L13.363961,12.363961 L13.363,21 L10,21 L10,9 L22,9 Z",
    id: "Combined-Shape",
    fill: "#4E4E4E",
    transform: "translate(16.000000, 15.000000) rotate(-45.000000) translate(-16.000000, -15.000000) "
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftArrowSymbol);
export default __webpack_public_path__ + "static/media/left-arrow-symbol.7080cb315323d4912b34f782472b8092.svg";
export { ForwardRef as ReactComponent };